import { PendingVoteButton } from "./PendingVoteButton";

export default PendingVoteButton;
